import { Input, InputNumber } from "antd";

const CustomInput = ({
  className = "",
  type = "text",
  placeholder = "",
  value,
  onChange,
  onPressEnter,
  icon = null,
  style = {},
  isNumber = false,
  min,
  max,
  isPassword,
  ...props
}) => {
  const baseClass = `!h-[46px] !rounded-[10px] hover:!border-[#E8E8E8] focus:!border-[#E8E8E8] focus:!border-[#C80000] focus:!shadow-none ${className}`;

  if (isNumber) {
    return (
      <InputNumber
        placeholder={placeholder}
        value={value}
        style={{ width: "100%", ...style }}
        className={baseClass}
        onChange={onChange}
        min={min}
        max={max}
        {...props}
      />
    );
  }

  if (isPassword) {
    return (
      <Input.Password
        placeholder={placeholder}
        value={value}
        style={style}
        className={baseClass}
        onChange={onChange}
        onPressEnter={onPressEnter}
        {...props}
      />
    );
  }

  return (
    <Input
      type={type}
      placeholder={placeholder}
      value={value}
      style={style}
      suffix={icon}
      className={baseClass}
      onChange={onChange}
      onPressEnter={onPressEnter}
      {...props}
    />
  );
};

export default CustomInput;